import { render, staticRenderFns } from "./NewsletterView.vue?vue&type=template&id=dca633ae"
import script from "./NewsletterView.vue?vue&type=script&lang=js"
export * from "./NewsletterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports